<script>
import Attachments from '@/views/Application/Manage/Accounts/Account/Attachments'

export default {
  extends: Attachments,
  data () {
    return {
      breadcrumb: {
        name: 'Attachments',
        route: { name: 'customerservice-accounts-account-attachments', params: { accountId: this.$route.params.accountId } }
      }
    }
  }
}
</script>
